import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';



@Component({
  selector: 'app-enter-email-for-forgotten-username',
  templateUrl: './enter-email-for-forgotten-username.component.html',
  styleUrls: ['./enter-email-for-forgotten-username.component.css']
})
export class EnterEmailForForgottenUsernameComponent implements OnInit {
  emailAddress = '';
  submitting = false;



  constructor(private http: HttpClient) { }



  ngOnInit() {
  }



  submitEmailAddress() {

    // If we are already submitting, stop the function
    if (this.submitting) {
      console.log('The function is already working...');
      return;
    }

    // Clear any old errors
    document.getElementById('incompleteFormError').style.display = 'none';

    // Trim whitespace from the emailAddress
    this.emailAddress = this.emailAddress.trim();
    
    // Make sure the form has been filled out - if not, stop the function and display an error
    if (this.emailAddress == '') {
      console.log('Incomplete form')
      document.getElementById('incompleteFormError').style.display = 'block';
      return;
    }


    
    // Hide the regular submit button and show 'Working...' instead
    this.submitting = true;




    // Send this emailAddress (SIS ID) to the backend
    // The backend will search SIS for a matching user, get the email address, and email them a password-reset link

    // Send the post request to update that user
    // Doing it this way, to the path /sendForgotUsernameEmail instead of the full path, avoids CORS errors.
    // This path is set up in the firebase.json file to direct to the cloud function.
    // Meaning - this request WILL NOT WORK ON LOCAL HOST - it will only work when deployed to Firebase.
    this.http.post('/sendForgotUsernameEmail', {emailAddress: this.emailAddress}).subscribe(
      data => {
        // Show the regular submit button
        this.submitting = false;
        // If we receive 'false' as a response, it did not find a user with a matching email address
        if (!data) {
          // TO DO
          alert('Error sending forgot username email, please contact an adminstrator at mis@elevenfifty.org');
        } else {

          // Email has been sent
          alert(data['message']);


        }
      },
      err => { this.submitting = false; alert('Error sending forgot username, please contact an adminstrator at mis@elevenfifty.org'); console.log('error in POST request to email the user, inside submitEmailAddress()'); console.log(err); },
      () => console.log('Completed POST request to email the user, inside submitEmailAddress()')
    )



  }



}
